// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkplusCfwAccountBanner_root__Ralq0"};